// BE bazen dış sağlayıcıdan (Google vb.) gelen profil fotoğrafı URL'sini kendi
// blob storage base URL'sinin peşine ekliyor:
// "https://hirethinkprodsense.blob.core.windows.net/image/https%3A//lh3.googleusercontent.com/..."
// Sonuç <img src> olarak çalışmıyor. Böyle bir değerde ikinci bir "http" varsa
// (yani dıştaki base URL'in İÇİNE gömülü, gerçek olan URL), onu ayıklayıp kullanır.
export function resolveImageUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const idx = url.lastIndexOf('http');
  if (idx <= 0) return url;
  const inner = url.slice(idx);
  try {
    return decodeURIComponent(inner);
  } catch {
    return inner;
  }
}
